<!-- 套餐组件 -->
<template>
  <div class="wrap-list-item">
    <div class="goods">
      <div class="goods-select">
        <van-checkbox
          v-model="isSelect"
          :disabled="isDisabled&&!isCompile"
          :checked-color="theme['APP_theme_color']">
        </van-checkbox>
      </div>
      <ul class="goods-item">
        <li v-for="item in cart" :key="item.ident">
          <div class="goods-item-img" :class="{'special-goods':+item.is_online_pay_goods ===1}">
            <img @click="toDetail(item.goods_id)" :src="item.thumbnail ||$notImg" alt="">
          </div>
          <div class="goods-item-info" @click="toDetail(item.goods_id)">
            <p class="goods-item-info-name"> {{item.general_name}} {{item.norms}}</p>
            <p class="goods-item-info-company"> {{item.produce_unit}}</p>
            <p class="goods-item-info-batch" v-show="item.batch_code.trim()"> 批号：{{item.batch_code}}</p>
            <div class="goods-item-info-bootom">
              <span class="price"><b>￥</b>{{float_change(item.singlePrice)}}</span>
              <span class="count">x{{item.quantity}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="goods-bottom">
      <div>
        <span class="tag">套装</span>
        <span class="price"><b>￥</b>{{float_change(cart[0]['realPrice'])}}</span>
      </div>
      <stepper v-on="$listeners" v-bind="$attrs" v-model="cart"/>
    </div>
  </div>
</template>

<script>
import Stepper from './stepper'
import { getTheme } from '@/assets/styles/theme.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    Stepper
  },

  props: {
    item: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
    isCompile: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      checked: false,
      cart: this.item
    }
  },

  computed: {
    ...mapGetters(['getSelectIdents']),
    theme () {
      return getTheme()
    },
    idents () {
      return this.cart.map(item => {
        return item.ident
      })
    },
    isDisabled () {
      return this.cart.some(item => {
        return +item.is_can_select === 0
      })
    },
    isSelect: {
      get: function () {
        return this.getSelectIdents.includes(this.idents.join(','))
      },
      set: function (newVal) {
        this.SELECT_IDENTS({ ident: this.idents.join(','), isSelect: newVal })
        this.$emit('loadCartData', true)
      }
    }
  },
  watch: {
    item: {
      deep: true,
      handler (val) {
        this.cart = JSON.parse(JSON.stringify(val))
      }
    },
    isCompile (newValue) {
      // 为了处理含嘛碱商品 在购物车不能别选中 但是编辑是能选中
      if (!newValue && this.isDisabled && this.getSelectIdents.includes(this.idents.join(','))) {
        this.SELECT_IDENTS({ ident: this.cart.ident, isSelect: false })
      }
    }
  },

  created () {
  },

  methods: {
    ...mapActions(['SELECT_IDENTS']),
    toDetail (id) {
      const { type } = this
      // location.href = `/product/detail?id=${id}&type=${type === 2 ? 2 : 1}`
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: id, type: type }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.wrap-list-item{
  border-top: 1px solid rgba(229,229,229,1);
  border-bottom: 1px solid rgba(229,229,229,1);
}
.goods{
  display: flex;
  &-select{
    width: 22px;
    @include center();
    margin-right: 21px;
  }
  &-bottom{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    padding-bottom: 15px;
    .price{
      font-size: 18px;
      margin-left: 10px;
      color: #EA2727;
      b{
        font-size: 12px;
      }
    }
    .tag{
      background: #EC5F63;
      color: #FFFFFF;
      font-size: 12px;
      padding: 2px;
      border-radius: 2px;
    }
  }
}
.goods-item{
  flex: 1;
  li{
    width: 100%;
    display: flex;
    padding-top: 15px;
    height: 110px;
    box-sizing: border-box;
  }
  &-img{
    width: 65px;
    height: 65px;
    border-radius: 4px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .special-goods{
    position: relative;
    &::before{
      display: inline-block;
      content: '';
      width: 41px;
      height: 41px;
      position: absolute;
      bottom: 0;
      right: 0;
      background: url('~@/assets/img/special-goods.png') no-repeat;
      background-size: 100%;
    }
  }
  &-info{
    flex: 1;
    box-sizing: border-box;
    /* border-bottom: 1px solid rgba(229,229,229,1); */
    margin-left: 15px;
    p{
      @include ell()
    }
    &-name{
      font-size: 14px;
      color: #333333;
    }
    &-company{
      font-size: 12px;
      color: #777777;
    }
    &-batch{
      font-size: 12px;
      color: #999999;
    }
    &-bootom{
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      .price{
        font-size: 18px;
        color: #999999;
        b{
          font-size: 12px;
        }
      }
      .count{
        display: inline-flex;
        align-items: center;
      }
    }
  }
}
</style>
